import { layoutMarginSmall } from '@issuu/silkscreen';
import React from 'react';
import styled from 'styled-components';

import { AdsPrimaryMobile } from './AdsPrimaryMobile';

const Root = styled.div`
    display: flex;
    align-items: center;
    justify-content: center;
    width: 100%;
    margin-bottom: ${layoutMarginSmall};
`;

export const AdsBeforeReader: React.FC = () => {
    return (
        <Root>
            <AdsPrimaryMobile idSuffix="beforeReader" />
        </Root>
    );
};
